import { render, staticRenderFns } from "./grid-import-boolean-editor-component.vue?vue&type=template&id=13d92c54"
import script from "./grid-import-boolean-editor-component.vue?vue&type=script&lang=ts"
export * from "./grid-import-boolean-editor-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
